import { render, staticRenderFns } from "./FullWidthImage.vue?vue&type=template&id=959d6752&"
import script from "./FullWidthImage.vue?vue&type=script&lang=js&"
export * from "./FullWidthImage.vue?vue&type=script&lang=js&"
import style0 from "./FullWidthImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports